import React from 'react';
import '../CSS/components/ItemList.css';

interface Item {
  itemID: number | null;
  varID: number | null;
}

interface ItemListProps {
  items: Item[];
}

const ItemList: React.FC<ItemListProps> = ({ items }) => {
  return (
    <div>
      <h4>Es wurden { items.length } Items in der Excel-Datei gefunden!</h4>
      <table className="item_table">
        <thead>
          <tr>
            <th>Zeile</th>
            <th>Item ID</th>
            <th>Var ID</th>
          </tr>
        </thead>
        <tbody>
          {items.map((item, index) => (
            <tr key={index}>
              <td>{index + 2}</td>
              <td>{item.itemID}</td>
              <td>{item.varID}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ItemList;
